import { Modal } from "react-bootstrap";
import React, { useEffect, useRef, useState } from 'react';
import { Link, useLocation, useNavigate } from "react-router-dom";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import * as model from '../../models/OffboardsModel';
import { apiError } from '../../helpers/ErrorHelper';
import { useAuth } from '../../context/AuthContext';
//import { useNotificationCount } from '../../../context/NotificationCountContext';
import { DatePicker, TextArea, InputFile, HiddenInput, MyReactSelect } from '../inputs/inputs';
import { getData as getLeavingReasons } from '../../models/LeavingReasonModel';

import { formatDataBeforeDisplay, formatDataBeforeSend, quickAddClient, validorSettings } from '../../helpers/GeneralHelper';
import SimpleReactValidator from 'simple-react-validator';

export const SetOffboard = ({module, showModal, setShowModal, onboardData}) => {
    
    const inputFields = {
        'offboard_onboard_id': '',
        'offboard_leaving_reason_id': '',
        'offboard_comments': '',
        'offboard_file_id': '',
        'offboard_last_day': '',
    }
    
    const formatOptions = [
        // {
        //     type: 'react-select',
        //     column: 'offboard_onboard_id',
        //     labelColumn: 'candidate_name'
        // },
        {
            type: 'react-datepicker',
            column: 'offboard_last_day',
        },
        {
            type: 'hidden',
            column: 'offboard_onboard_id',
            labelColumn: '_offboard_id'
        },
    ];
    const navigate = useNavigate(); 

    const { state } = useAuth();
    let user_data = state.user_data;
    const location = useLocation();
    //const module = location.state?.module;
    const [loading, setLoading] = useState(false);
    const [leavingReasons, setLeavingReasons] = useState([]);
    const [errors, setErrors] = useState({});
    const [fields, setFields] = useState(inputFields);
    //const [offboard_onboard_id, setOnboardId] = useState('');
    useEffect(() => {
        const fetchLeavingReasons = async() => {
            try {
                let apiParam = {user_token: user_data.user_token, page: 1, limit: -1};
                const response = await getLeavingReasons(apiParam);
        
                if (typeof response != typeof undefined) {
                    let options = [];
                    response.leaving_reasons.forEach(function(item) {
                        options.push({
                            value: item._reason_id,
                            label: item.reason_name
                        });
                    });
                    setLeavingReasons(options);
                }
            } catch (error) {
                console.error(error);
            }
        }
        fetchLeavingReasons();
    }, []);
    useEffect(() => {
        if (onboardData) {
            setFields({offboard_onboard_id : onboardData._onboard_id});
            setErrors({});
        }
    }, [onboardData]);
    const closeModal = () =>{
        setShowModal(false);
    };
    const validator = useRef(new SimpleReactValidator(validorSettings()));

    const submit = async(e) => {
        e.preventDefault();

        if (! validator.current.allValid()) {
            toast.error('Please check the form errors!');
            return;
        }
        validator.current.hideMessages();
    
        setLoading(true);

        try {
            // Clear previous errors
            setErrors({});
            const formData = formatDataBeforeSend(fields, inputFields, formatOptions);
            
            let response;
            response = await model.create(user_data.user_token, formData);
        
            if (response.status) {
                toast.success(response.message);
                //model.saveToStorage(response.data[module.key], response.data.pagination);
                navigate('/offboards');
            } else {
                setErrors(response.error);
                toast.error(response.message);
            }
        } catch (error) {
            apiError(error);

            if (error.response?.data?.invalid_token == 1) {
                navigate('/re-login');
            }
        }
        setLoading(false);
    }
    return (
        <Modal show={showModal} onHide={closeModal} size='xl' backdrop="static">
            <Modal.Header closeButton>
                <Modal.Title>Set Offboard</Modal.Title>
            </Modal.Header>
    
            <form onSubmit={submit}>
                <Modal.Body>
                    <div className="row gy-2">
                        <div className="col-xl-4 mb-3">
                            {/* <input type="hidden" name="offboard_onboard_id" value={offboard_onboard_id} /> */}
                            <HiddenInput column="offboard_onboard_id" fields={fields} setFields={setFields} errors={errors} value={onboardData._onboard_id} />
                            <label className="form-label">Candidate <span className="text-danger">*</span></label>
                            <input type="text" className="form-control" placeholder="Candidate" readonly="true" value={onboardData.candidate_name} />
                                {/* {errors.offboard_onboard_id && <p style={{ color: 'red' }}>{errors.offboard_onboard_id}</p>} */}
                        </div>
                        <div className="col-xl-4 mb-3">
                            <DatePicker column="offboard_last_day" label="Last Day of Work" required={true} fields={fields} setFields={setFields} errors={errors}  />
                        </div>

                        <div className="col-xl-4 mb-3">
                            <InputFile column="offboard_file_id" label="Document" required={false} fields={fields} setFields={setFields} errors={errors}  />
                            <small>Formats: PDF & DOCX</small>
                        </div>

                        <div className="col-xl-6 mb-3">
                            {/* <TextArea column="offboard_leaving_reason_id" label="Leaving Reason" required={true} fields={fields} setFields={setFields} errors={errors}  /> */}
                            <MyReactSelect column="offboard_leaving_reason_id" label="Leaving Reason" options={leavingReasons} required={true} fields={fields} setFields={setFields} errors={errors} />
                        </div>

                        <div className="col-xl-6 mb-3">
                            <TextArea column="offboard_comments" label="Comments" fields={fields} setFields={setFields} errors={errors}  />
                        </div>
                    </div>
                </Modal.Body>
    
                <Modal.Footer>
                    <button type="button" className="btn btn-light" onClick={closeModal}>Cancel</button>
                    <button className="btn btn-primary" disabled={loading}>
                    {loading ? <span><span className="spinner-border spinner-border-sm align-middle"></span> Loading...</span> : 'Submit'}
                    </button>
                </Modal.Footer>
            </form>
        </Modal>
    );
};